var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCameraEmptyDisabled = function SvgCameraEmptyDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7 6H14c.6 0 1 .4 1 1v3.3c0 .3.1.5.3.7l1 1c.3.4.9.4 1.3.1L22 9v8c0 .6.4 1 1 1s1-.4 1-1V7c0-.4-.2-.7-.5-.9s-.7-.1-1.1.1L17.1 10l-.1-.1V7c0-1.7-1.3-3-3-3h-3.3c-.6 0-1 .4-1 1s.4 1 1 1M23.7 22.3l-7-7-11-11-4-4C1.3-.1.7-.1.3.3s-.4 1 0 1.4L2.6 4C1.1 4.2 0 5.5 0 7v10c0 1.7 1.3 3 3 3h11c1.2 0 2.3-.7 2.8-1.8l5.5 5.5c.4.4 1 .4 1.4 0s.4-1 0-1.4M15 17c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h1.6L15 16.4z",
    className: "camera-empty-disabled_svg__st0"
  }))));
};
export default SvgCameraEmptyDisabled;